import { render, staticRenderFns } from "./CsrWhiteDragons.vue?vue&type=template&id=20e63fea&scoped=true"
import script from "./CsrWhiteDragons.vue?vue&type=script&lang=js"
export * from "./CsrWhiteDragons.vue?vue&type=script&lang=js"
import style0 from "./CsrWhiteDragons.vue?vue&type=style&index=0&id=20e63fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e63fea",
  null
  
)

export default component.exports